export const DEFAULT_LOCALE = 'en-AU' as const
export const GERMAN_LOCALE = 'de-DE' as const

export function getCountryCodeFromLocale(locale: string): string {
  return new Intl.Locale(locale).region ?? ''
}

export function getNativeLanguageName(locale: string): string {
  try {
    return (
      new Intl.DisplayNames(locale, { type: 'language' }).of(
        new Intl.Locale(locale).language,
      ) ?? locale
    )
  } catch {
    return locale
  }
}
